// Router.js

import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import Login from '../pages/Login';
import Main from '../pages/Main';
import NotFound from '../pages/NotFound';
import { useAuth } from '../contexts/CommonCtx';

const Router = (props) => {
    //console.log('router_props', props);

    const { user } = useAuth();
    //console.log('router_user', user);

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/signin" element={ <Login /> } />
                <Route path="/" element={ user.user_id ? <Main /> : <Navigate replace to='/signin' /> } />
                <Route path="*" element={ <NotFound /> } />
            </Routes>
        </BrowserRouter>
    );
};

export default Router;


